<script lang="ts" setup>
import { twMerge } from 'tailwind-merge'
import { cva } from 'class-variance-authority'
import { RouteLocationNamedRaw } from 'vue-router'

const route = useRoute()

const linkClasses = cva('', {
  variants: {
    intent: {
      'border-bottom-purple': 'pb-1 font-medium',
      'bg-purple': 'p-2 text-uiGray-200',
      'bg-gray': 'p-2 text-uiGray-200'
    },
    active: {
      true: '',
      false: ''
    }
  },
  compoundVariants: [
    {
      intent: 'border-bottom-purple',
      active: false,
      class: 'text-uiGray-600'
    },
    {
      intent: 'border-bottom-purple',
      active: true,
      class: 'text-uiGray-200 border-b-[3px] border-bottom border-uiPrimary-400'
    },
    {
      intent: 'bg-purple',
      active: false,
      class: ' bg-uiGray-300'
    },
    {
      intent: 'bg-purple',
      active: true,
      class: 'bg-ocean rounded border border-uiGray-300'
    },
    {
      intent: 'bg-gray',
      active: false,
      class: ''
    },
    {
      intent: 'bg-gray',
      active: true,
      class: 'bg-uiGray-300'
    }
  ]
})

const props = withDefaults(
  defineProps<{
    isIndex?: boolean
    to: RouteLocationNamedRaw
    intent?: 'border-bottom-purple' | 'bg-purple' | 'bg-gray'
    class?: string
  }>(),
  {
    isIndex: false,
    intent: 'border-bottom-purple',
    class: ''
  }
)

const isActive = computed(() => {
  if (props.isIndex) {
    return route.name === props.to.name
  }

  return route.name?.toString().startsWith(props.to.name?.toString() || '')
})
</script>

<template>
  <NuxtLink
    :to="props.to"
    v-bind="$attrs"
    :class="
      twMerge(
        linkClasses({
          intent: props.intent,
          active: isActive,
          class: props.class
        })
      )
    "
  >
    <slot v-bind="{ isActive }" />
  </NuxtLink>
</template>
